import axios from 'axios'

export const logger = data => {
    return axios.post('/ajax/logger', data)
}

/**
 * Notify backend that the global error modal was shown (for logging/analytics).
 * @param {Object} data - { reason: string, userId?: number, message?: string, stack?: string, url?: string }
 */
export const logErrorModal = data => {
    return axios.post('/ajax/error-modal', data)
}
export const checkVersion = () => {
    return axios.get('/meta.json?nc=' + new Date().getTime())
}
export const activateUser = data => {
    return axios.post('/ajax/activate', data)
}
export const loadUser = userId => {
    return axios.post('/ajax/load-user', { userId })
}
export const createLoginLink = data => {
    return axios.post('/ajax/login-link', { ...data })
}
export const requestNewAccount = data => {
    return axios.post('/ajax/request-account', data)
}
export const requestNewLink = userId => {
    return axios.post('/ajax/request-activation-link', { user_id: userId })
}
export const sendSlackNotification = data => {
    return axios.post('/ajax/send-notification', data)
}

export const saveAnalyticsData = data => {
    return axios.post('ajax/save-analytics', data)
}
